<template>
    <li v-if="menu.total_products > 0"
        v-bind:class="[menu.active ? 'active dropdown-tree open-tree' : 'dropdown-tree-a']">
        <a
                v-on:click.prevent="addFilter(menu, type, parent)"
                v-bind:href="buildUrl(menu, type, parent)"
        >

            <span class="badge pull-right"> <small>{{menu.total_products}}</small> </span>
            <small class="cat-item"
                   :data-titleh1="titleh1Category">
                {{menu.name ? menu.name : menu.description}}
            </small>
        </a>
        <span
                v-if="menu.products_groups"
                class="arow"
        ></span>
        <ul v-if="showSubCategory() && menu.products_groups" class="category-level-2 dropdown-menu-tree">
            <li class="dropdown-tree"
                v-for="(subcat, index) in menu.products_groups"
                v-if="subcat.total_products > 0"
            >
                <a
                        class="subItem"
                        v-on:click.prevent="addFilter(subcat, type, menu)"
                        v-bind:href="buildUrl(subcat, type, menu)"
                >

                    <span class="badge pull-right"> <small>{{subcat.total_products}}</small> </span>
                    <small class="cat-sub-item"  v-bind:data-titleh1="buildH1TitleGroup(subcat)">{{subcat.name ? subcat.name : subcat.description}}</small>
                </a>
            </li>
        </ul>
    </li>
</template>

<script>
    export default {
        name: 'menu-item',
        data() {
            return {
                titleh1Category : this.buildH1TitleCategory(this.menu),
            }
        },
        props: ['menu', 'type', 'parent', 'queryParams'],
        methods: {
            showSubCategory: function () {
                return !!(this.queryParams && this.queryParams.hasOwnProperty('category'))
            },
            addFilters: function (filters) {
                filters.forEach((filter) => {
                    this.$emit('addFilter', filter);
                });
            },
            addFilter: function (filter, type, parent) {
                this.$emit('addFilter', {
                    filter: filter,
                    type: type,
                    parent: parent,
                });
            },
            buildUrl: function (filter, type, parent) {

                let queryFilter = {
                    [filter.key]: filter.slug ? filter.slug : filter.code
                };

                if (typeof parent !== 'undefined') {
                    queryFilter = {[parent.key]: parent.slug ? parent.slug : parent.code, ...queryFilter}
                }

                let queryParams = {...this.$parent.queryParams, ...queryFilter};


                return '/' + queryParams.lang + '/' + queryParams.top + '/' + queryParams.category + (queryParams.group ? '/' + queryParams.group : '');
            },
            buildH1TitleCategory: function (menu) {

                return menu && menu.category_meta && menu.category_meta.title_h1 ? menu.category_meta.title_h1 : menu.description
            },
            buildH1TitleGroup: function (subcat) {
                return subcat && subcat.group_meta && subcat.group_meta.title_h1 ? subcat.group_meta.title_h1 : subcat.description
            }
        },
    }

</script>

<style scoped>

</style>
